import { useSnackbar } from 'notistack'
import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import { usePostStartPayment } from '~/features/payment/queries/usePayment'
import { PaymentDivideType } from '~/features/payment/types/payment'
import { useSpecialPerformanceDetail } from '~/features/special-performance/queries/useSpecialPerformance'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'
import { isPaymentModalOpenState } from '~/shared/states'
import theme from '~/shared/styles/theme'

// TODO 공연 상세 페이지 이미지로 넣기

const GOODS_ID = 21

function PerformanceDetail() {
  // TODO 우선 하드코딩으로 21 넣어 놓음
  // 추 후 특별 공연 페이지가 리스트로 나올 시 변수로 수정 필요

  const { isLoading, data } = useSpecialPerformanceDetail(GOODS_ID.toString())

  const { mutate: paymentStartMutate } = usePostStartPayment()

  const [_isPaymentModalOpen, setIsPaymentModalOpen] = useRecoilState(
    isPaymentModalOpenState,
  )

  const { enqueueSnackbar } = useSnackbar()

  const { event_ticket_info: eventTicketInfo } = data || {}

  const handleClickBuy = () => {
    if (!eventTicketInfo?.availableTime) {
      enqueueSnackbar('구매 가능한 기간이 아닙니다.', { variant: 'error' })
    } else if (eventTicketInfo.remain_quantity === 0) {
      enqueueSnackbar('티켓이 모두 판매되었습니다.', { variant: 'error' })
    } else {
      paymentStartMutate(
        {
          paymentInfo: {
            goods_id: GOODS_ID,
            divide: PaymentDivideType.TICKET,
            quantity: 1,
            option_1_quantity: 0,
          },
        },
        {
          onSuccess: (res) => {
            if (!res.errorMsg) {
              setIsPaymentModalOpen({
                contents: {
                  productName: '서울 인디 아이돌 페스티벌',
                  amount: res.data.payment_info.total_amount,
                  orderId: res.data.payment_info.order_code,
                  userId: res.data.payment_info.user_id,
                  paymentKey: res.data.payment_info.payment_key,
                  paymentType: res.data.payment_info.payment_type,
                },
                isOpen: true,
              })
            } else {
              enqueueSnackbar(res.errorMsg, { variant: 'error' })
            }
          },
        },
      )
    }
  }

  return (
    <Wrapper>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <ContentImage
            src="https://static.illustar.net/temp/specialperformance.webp"
            alt="special-performance"
          />
          <TicketPurchaseButtonBox
            onClick={handleClickBuy}
            className={`${
              eventTicketInfo && eventTicketInfo.remain_quantity === 0
                ? 'disabled'
                : ''
            }`}
            disabled={
              eventTicketInfo && eventTicketInfo.remain_quantity === 0
                ? true
                : false
            }
          >
            <TicketPurchaseContent>
              <PerformanceTitle>SEOUL INDIE IDOL FESTIVAL</PerformanceTitle>
              <PerformanceInfo>
                강남구 논현1동 리엠아트센터 | 2024.07.07 일요일 14시
              </PerformanceInfo>
              <PerformancePrice>30,000원</PerformancePrice>
            </TicketPurchaseContent>
            <TicketPurchaseButton
              className={`${
                eventTicketInfo && eventTicketInfo.remain_quantity === 0
                  ? 'disabled'
                  : ''
              }`}
            >
              {eventTicketInfo && eventTicketInfo.remain_quantity === 0
                ? '매진'
                : '예매하기'}
            </TicketPurchaseButton>
          </TicketPurchaseButtonBox>
        </>
      )}
    </Wrapper>
  )
}

export default PerformanceDetail

const Wrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  height: 100%;
  min-height: 50vh;
`

const ContentImage = styled.img`
  width: 100%;
  margin-bottom: 200px;

  @media ${theme.device.medium} {
    margin-bottom: 50px;
  }
`

const TicketPurchaseButtonBox = styled.button`
  cursor: pointer;

  position: fixed;
  z-index: ${theme.zIndex.aboveFixed};
  right: 0;
  bottom: 5%;
  left: 0;

  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-around;

  box-sizing: border-box;
  width: 70%;
  max-width: 1080px;
  height: auto;
  margin-right: auto;
  margin-left: auto;
  padding: 32px;

  font-size: 32px;
  color: ${theme.colors.black};

  background-color: ${theme.colors.white};
  border: 2px solid #8877b5;
  border-radius: 100px;
  box-shadow: rgb(149 157 165 / 80%) 0 8px 24px;

  transition: opacity 0.3s ease-in-out;

  &.disabled {
    cursor: not-allowed;
  }

  @media ${theme.device.large} {
    flex-direction: column;
    gap: 10px;
    justify-content: center;

    height: auto;
    margin-bottom: ${theme.size.footerHeight};
    padding: 20px;

    font-size: 18px;

    border-radius: 20px;
  }
`

const TicketPurchaseContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: start;

  @media ${theme.device.large} {
    gap: 20px;
    align-items: center;
    font-size: 18px;
  }
`

const PerformanceTitle = styled.div`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 800;

  @media ${theme.device.large} {
    font-size: 18px;
  }
`

const PerformanceInfo = styled.div`
  font-size: 18px;

  @media ${theme.device.large} {
    display: none;
    font-size: 16px;
  }
`

const PerformancePrice = styled.div`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;

  @media ${theme.device.large} {
    font-size: 18px;
  }
`

const TicketPurchaseButton = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  width: 200px;
  padding: 20px;

  color: ${theme.colors.white};

  background-color: #594983;
  border-radius: 50px;

  &.disabled {
    cursor: not-allowed;
    background-color: rgb(128 128 128 / 80%);
  }

  @media ${theme.device.large} {
    width: 100%;
    height: 20px;
    border-radius: 20px;
  }
`
